import { render, staticRenderFns } from "./AppealQuestionnaire.vue?vue&type=template&id=be09836e&scoped=true&lang=pug&"
import script from "./AppealQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AppealQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./AppealQuestionnaire.vue?vue&type=style&index=0&id=be09836e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be09836e",
  null
  
)

export default component.exports